import Vue from 'vue/dist/vue.js'

import GlobalSearch from './partials/GlobalSearch'
import GlobalSearchPage from './partials/GlobalSearchPage'

if(document.querySelector('#v-search')) GlobalSearch(Vue);
if(document.querySelector('#v-global-search-page')) GlobalSearchPage(Vue);